export default __webpack_public_path__ + "static/media/chart.6fb8b125.png";